import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Observable } from 'rxjs';
import { JobRole } from '@app/onboarding/services/onboarding.service';
import { OnboardingStateService } from '@app/onboarding/services/onboarding-state.service';
import { AuthService } from '@app/shared/services/auth.service';
import { AuthUser } from '@app/account/account-api.model';
import { TranslateService } from '@ngx-translate/core';
import { WebEnvironmentService } from '@app/shared/services/web-environment.service';

@Component({
  selector: 'dgx-role-select-items',
  templateUrl: './role-select-items.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoleSelectItemsComponent implements OnInit {
  public i18n = this.translateService.instant([
    'Core_Empty_Image_Alt',
    'Onboarding_SearchRoles_NoRoleAssigned',
    'Onboarding_SearchRoles_VisitIntegration',
  ]);

  public integrationLoading: boolean = false;
  public integrationSeletedRole: JobRole;
  public noRoleImage: string = this.getBlobUrl(
    '/content/img/emptystate/empty-notifications.svg'
  );
  private authUser: AuthUser;

  @Input() public featuredRoles: Observable<JobRole[]>;
  @Input() public jobRoleIntegrationProvider?: string = '';
  constructor(
    private onboardingStateService: OnboardingStateService,
    private authService: AuthService,
    private translateService: TranslateService,
    private webEnvironmentService: WebEnvironmentService
  ) {}

  public ngOnInit(): void {
    this.authUser = this.authService.authUser;
  }

  public onRoleSelected(
    event: MouseEvent,
    role: JobRole,
    roleList: JobRole[]
  ): void {
    event.stopPropagation();
    event.preventDefault();
    // update if any roles are currently selected remove them
    const currentSelected = roleList.find((role) => role.selected === true);
    if (currentSelected && currentSelected.id !== role.id) {
      currentSelected.selected = false;
    }
    // update the role that is selected
    role.selected = !role.selected;
    this.onboardingStateService.currentRoleChange(role.selected ? role : null);
  }

  /**
   * Prevent any action on click a assigned integration role.
   */
  public integrationRole(event: Event) {
    event.stopPropagation();
    event.preventDefault();
  }

  private getBlobUrl(url: string): string {
    return this.webEnvironmentService.getBlobUrl(url);
  }
}
